module.exports = __webpack_public_path__ + "img/section31.915ade17.png";